import loginReducer from "./loginReducers";

import { combineReducers } from "redux";

const reducers = combineReducers({
	loginReducer,
});

export default reducers;
